import Router from './router'
import Cookies from 'js-cookie'
import {getWxLoginInfo, isLogin, isWxBrowser, setLoginState, setWxLoginInfo, urlEncode} from '@/utils/commonUtils'
import {Toast} from 'vant'
import Config from '@/utils/config'
import store from '../store'


Router.beforeEach((to, from, next) => {

    dealQuery(to, next); //处理参数

    dealBack(to, next);  //处理返回

    checkLoginState(to, next); //检查登录状态

    weiXinAuthorization(to, next); //微信授权

});

function dealQuery(to, next) {
    //type:0 益宝  1 心智宝
    if (to.query.type) {
        Cookies.set('type', to.query.type);
    } else {
        to.query['type'] = Cookies.get('type') || '0'; //无type是默认为益宝
        next(to);
    }
    let shareId = to.query.shareId
    if (shareId && typeof shareId != "undefined" && shareId != null && shareId != "") { // 链接中有分享ID时，保存且拼接
        Cookies.set('shareId', shareId);
    } else {
        if (Cookies.get('shareId')) {
            to.query['shareId'] = Cookies.get('shareId');
            next(to);
        }
    }

    if (to.query.currentUrl) {
        Cookies.set('currentUrl', to.query.currentUrl);
        to.query['currentUrl'] = null;
        next(to);
    }
}

function dealBack(to, next) {
    if (to.path === '/login' && isLogin()) { // 登录状态前提下返回到登录页面时，去首页
        next('/');
    }
    if (to.path === '/auth' && !Cookies.get('currentUrl')) { //星贝授权成功后，在返回时去首页
        next('/');
    }
}

function checkLoginState(to, next) {
    if (!to.meta.login) { // 目的页面 不需要 登录
        next();
    } else { // 目的页面 需要 登录
        if (!isLogin()) { //session为空值时需要登录（无论哪种形式的登录，登录成功后都会有session信息）
            const type = to.query.type || Cookies.get('type') || '0';
            next({path: '/login', query: {redirectUrl: to.path, type: type}})
        } else { //有session信息，是已登录状态
            next();
        }
    }
}

function  weiXinAuthorization(to, next) {
    if (to.path === '/login' && isWxBrowser()) {
        if (getWxLoginInfo()) {
            return;
        }

        const type = to.query.type;

        let redirectUrl = to.query.redirectUrl || '/';
        if(type =='3'){
            redirectUrl = '/Ahome'
        }
        const code = to.query.code;

        let appId = Config.wxAppId[type];
        if(process.env.NODE_ENV!=='production'){
            //测试公众号
            appId = Config.wxAppId[100];
        }
        if(type != '3'){
            let redirectUrl = to.query.redirectUrl || '/';
        }else{
            let redirectUrl = to.query.redirectUrl || '/Ahome';
        }

        if (code) {// //获取微信code
            Toast.loading({
                mask: true,
                message: '加载中...'
            });
            window.axios.get('/wx/login', {params: {appId: appId, code: code}}).then(res => {
                Toast.clear();
                setWxLoginInfo(res.data.unionId);
                window.axios.get('/user/wx', {
                    params: {
                        unionId: res.data.unionId,
                        openId: res.data.openId,
                        headImgUrl: res.data.headImgUrl,
                        nickname: res.data.nickname,
                        type: type
                    }
                }).then(result => {
                    const unionId = result.data.unionId;
                    const openId = result.data.openId;
                    const session = result.data.session;
                    const headImgUrl = result.data.headImgUrl;
                    const nickname = result.data.nickname;
                    Cookies.set('nickname', nickname)
                    Cookies.set('headImgUrl', headImgUrl)
                    localStorage.setItem("nickname",nickname)
                    localStorage.setItem("headImgUrl",headImgUrl)
                    to.query['headImgUrl'] = headImgUrl;
                    to.query['nickname'] = nickname;
                    if(openId){
                        localStorage.setItem("openId",openId)
                        Cookies.set('openId', openId)
                        to.query['openId'] = openId;

                    }
                    if (unionId) {
                        localStorage.setItem("unionId",unionId)
                        Cookies.set('unionId', unionId)
                        to.query['unionId'] = unionId;

                    }

                    if (!result.data.userInfo) {
                        next(to)
                    }
                    else {//存在用户信息说明绑定了手机号，直接登陆
                        if (session) {
                            setLoginState(session)
                        }
                        store.dispatch('UpdateUserInfo', result.data.userInfo)
                        store.dispatch('UpdateRole', result.data.role)
                        next(redirectUrl)
                    }
                })
            }).catch(err => {
                Toast.clear();
            })
        } else {
            let REDIRECT_URI = urlEncode(process.env.VUE_APP_SHARE_URL + to.fullPath);
            if (type == '1') {
                REDIRECT_URI = urlEncode(process.env.VUE_APP_SHARE_XZB_URL + to.fullPath);
            }

            //跳转微信链接
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        }
    }
}
